<script setup lang="ts">
	import { gsap } from "gsap"
	import { onClickOutside } from '@vueuse/core'

	const isOpen = ref(0)
	const toggle = ref(null)
	const content = ref(null)
	const wrapper = ref(null)

	const init = ( () => {
		gsap.set(content.value, { width: 0, opacity:0 })
		gsap.set(toggle.value, { width: () => { return screen.width >= 1180 ? 60 : screen.width >= 768 ? 52 : 48 }, height: () => { return screen.width >= 1180 ? 60 : screen.width >= 768 ? 52 : 48 }, x: 0, y: 0 })
	})

	onMounted(() => {
		init()
		useEventListener(window, 'resize', function(){
			init()
		})
	})

	const toggleBtn = (event:any) => {
		if(isOpen.value === 0 ) {
			gsap.to(toggle.value, { width: () => { return screen.width >= 1180 ? 50 : screen.width >= 768 ? 42 : 38 }, height: () => { return screen.width >= 1180 ? 50 : screen.width >= 768 ? 42 : 38 }, x: -5, y: 5, duration: 0.35, ease: "power4.inOut" })
			gsap.to(content.value, { width: () => { return screen.width >= 1180 ? 200 : screen.width >= 991 ? 190 : screen.width >= 575 ? 170 : 150 }, opacity: 1, duration: 0.5, ease: "back.inOut" })
		} else {
			closeArea()
		}
		isOpen.value = (isOpen.value - 1) * -1
	}

	const closeArea = () => {
		gsap.to(toggle.value, { width: () => { return screen.width >= 1180 ? 60 : screen.width >= 768 ? 52 : 48 }, height: () => { return screen.width >= 1180 ? 60 : screen.width >= 768 ? 52 : 48 }, x: 0, y: 0, duration: 0.35, ease: "power4.inOut" })
		gsap.to(content.value, { width: 0, opacity:0, duration: 0.5, ease: "power4.in" })
	}

	onClickOutside(wrapper, event => {
		if(isOpen.value) {
			closeArea()
			isOpen.value = 0
		}
	})
</script>

<template>
	<div ref="wrapper" class="relative group" aria-label="Telefonnummer anzeigen" title="Telefonnummer anzeigen">
		<div ref="content" class="flex justify-center h-[48px] md:h-[52px] lg:h-[60px] bg-green group-hover:bg-blue rounded-full pr-[48px] md:pr-[52px] lg:pr-[60px] shadow-lg overflow-hidden">
			<a href="tel:+49357148850" title="Nummer jetzt anrufen" class="my-auto text-white text-[14px] md:text-[16px] lg:text-[20px] whitespace-nowrap pt-1 ps-5">03571 4885-0</a>
		</div>
		<button ref="toggle" aria-label="Telefonnummer anzeigen" @click="toggleBtn($event)" class="absolute right-0 top-0 flex w-[48px] h-[48px] md:w-[52px] md:h-[52px] lg:w-[60px] lg:h-[60px] rounded-full bg-green group-hover:bg-blue border-green p-0 cursor-pointer">
			<span class="m-auto">
				<svg xmlns="http://www.w3.org/2000/svg" width="32.835" height="32.895" viewBox="0 0 32.835 32.895" class="w-[28px] lg:w-[32px] m-auto">
					<path id="Icon_feather-phone" data-name="Icon feather-phone" d="M33,25.38v4.5a3,3,0,0,1-3.27,3,29.685,29.685,0,0,1-12.945-4.6,29.25,29.25,0,0,1-9-9A29.685,29.685,0,0,1,3.18,6.27,3,3,0,0,1,6.165,3h4.5a3,3,0,0,1,3,2.58A19.26,19.26,0,0,0,14.715,9.8a3,3,0,0,1-.675,3.165l-1.905,1.9a24,24,0,0,0,9,9l1.9-1.905a3,3,0,0,1,3.165-.675,19.26,19.26,0,0,0,4.215,1.05A3,3,0,0,1,33,25.38Z" transform="translate(-1.667 -1.5)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
				</svg>
			</span>
		</button>
	</div>
</template>
